export const formatFloatValues = (values: Array<number | null | undefined>) => {
  return values.map((value) =>
    value ? (value !== 0 ? `${(value * 100).toFixed(1)}%` : value) : ""
  );
};
